module.exports = __webpack_public_path__ + "static/img/js_03.f9f8761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/js_03.jpg
// module id = KNHB
// module chunks = 0